import React, {useState, useEffect} from "react";
import Popup from "../../components/Popup/Popup";
import SelectorPopup from "../../components/SelectorPopup/SelectorPopup";

import {callAPI} from "../../utils/utils";
import "./Domains.scss";


const AddDomainDialogMode = (props) => {
  const options = [
    {
      id: 'register',
      title: 'Neue Domain registrieren lassen',
      text: <>Du kannst beliebig viele Domains mit einer Webseite verbinden. Wähle dies falls du eine neue Domain bestellen möchtest.</>
    },
    {
      id: 'transfer',
      title: 'Bestehende Domain vom bisherigen Provider zu page4 umziehen',
      text: 'Für den Umzug brauchst du einen sogenannten Authorisierungs-Code (AUTH-Code). Diesen bekommst du vom bisherigen Provider'
    },
    {
      id: 'link',
      title: 'Bestehende Domain mit deiner page4 Website verlinken',
      text: 'Wenn du deine Domain beim bisherigen Provider lassen willst, kannst du die Domain einfach verlinken. Wir tragen die Domain in unsere Verwaltung ein, du musst bei deinem Provider die A-Records auf unsere IP Adresse setzen. Welche für deine Seite gilt teilen wir dir per Email mit.'
    }
  ];

  return <SelectorPopup
    title={props.title}
    confirmButton={'Weiter'}
    onConfirm={props.onSelect}
    onCancel={() => props.onSelect(false)}
    default={'register'}
    options={options}
  />
}

const AddDomainDialogLink = (props) => {
  const domainPackages = props.domainPackages;
  const account = props.account;
  const [domain, setDomain] = useState("");
  const [tld, setTld] = useState("de");

  const checkDomain = (domain) => {
    const tokens = domain.toLowerCase().replace(/[^a-z0-9äöü\-.\s]/gi, '').split(".");
    setDomain(tokens[0]);
    if (domainPackages.find((element) => element.tld === tokens[1]))
      setTld(tokens[1]);
  }

  const linkDomain = () => {
    callAPI("domain", "POST", "order", {domain: domain, tld: tld, accountId: account.id, mode: 'link'}).then((response) => {
      props.onClose(true);

    });
  }

  const tldSelectorHtml = domainPackages.map((element) => {
    return <option selected={element.tld === tld} value={element.tld}>.{element.tld}</option>
  });

  return (
    <Popup
      title={'Domain hinzufügen für Webseite #' + ('00000' + account.id).slice(-5)}
      confirmButton={"Anlegen"}
      cancelButton={"Abbrechen"}
      onConfirm={() => linkDomain()}
      onCancel={() => props.onClose(false)}
      disableConfirm={!domain}
    >
      <div className={'add-domain-dialog'}>
        <div className={'info-text'}>
          Bitte hier die Domain eintragen, die mit deiner Seite verlinkt werden. Bitte auch die korrekte Domain-Endung auswählen. Wir schicken dir danach Infos, was du bei deinem alten Provider eintragen musst.
        </div>
        <div className={'input-box'}>
          <input value={domain} onChange={(e) => checkDomain(e.target.value)}/>
          <select onChange={(e) => setTld(e.target.value)}>{tldSelectorHtml}</select>
        </div>
      </div>
    </Popup>
  );
};

const AddDomainDialogTransfer = (props) => {
  const domainPackages = props.domainPackages;
  const account = props.account;
  const [domain, setDomain] = useState("");
  const [tld, setTld] = useState("de");
  const [authCode, setAuthCode] = useState("");

  const checkDomain = (domain) => {
    const tokens = domain.toLowerCase().replace(/[^a-z0-9äöü\-.\s]/gi, '').split(".");
    setDomain(tokens[0]);
    if (domainPackages.find((element) => element.tld === tokens[1]))
      setTld(tokens[1]);
  }

  const transferDomain = () => {
    callAPI("domain", "POST", "order", {domain: domain, tld: tld, accountId: account.id, authCode: authCode, mode: 'transfer'}).then((response) => {
      props.onClose(true);

    });
  }

  const tldSelectorHtml = domainPackages.map((element) => {
    return <option selected={element.tld === tld} value={element.tld}>.{element.tld}</option>
  });

  const currentPackage = domainPackages.filter((element) => element.tld === tld)[0]

  return (
    <Popup
      title={'Domain hinzufügen für Webseite #' + ('00000' + account.id).slice(-5)}
      confirmButton={"Kostenpflichtig bestellen"}
      cancelButton={"Abbrechen"}
      onConfirm={() => transferDomain()}
      onCancel={() => props.onClose(false)}
      disableConfirm={!domain}
    >
      <div className={'add-domain-dialog'}>
        <div className={'info-text'}>
          Trage bitte die Domain ein die transferriert werden soll
        </div>
        <div className={'input-box'}>
          <input value={domain} onChange={(e) => checkDomain(e.target.value)}/>
          <select onChange={(e) => setTld(e.target.value)}>{tldSelectorHtml}</select>
        </div>
        <div className={'info-text'}>
          Trage bitte den Authcode bzw. Transfercode ein den du von deinem bisherigen Provider erhalten hast
        </div>
        <div className={'input-box'}>
          <input value={authCode} onChange={(e) => setAuthCode(e.target.value)} placeholder={"Bitte hier Authcode eintragen"}/>
        </div>
        <div className={'info-text'} style={{marginTop: 30, marginBottom: 30}}>
          Für den Transfer und die Verwaltung der Domain fallen Kosten in Höhe von <b>{currentPackage.price}€ pro Monat bzw. {currentPackage.price * 12}€ pro Jahr inkl. MwSt. </b> an.<br/>Der Betrag wird jährlich im Voraus über die bevorzugte Zahlungsart abgerechnet.
        </div>
      </div>
    </Popup>
  );
};

const AddDomainDialogRegister = (props) => {
  const domainPackages = props.domainPackages;
  const account = props.account;
  const [domain, setDomain] = useState("");
  const [tld, setTld] = useState("de");
  const [checkResult, setCheckResult] = useState(0);

  const checkUserInput = (domain) => {
    const tokens = domain.toLowerCase().replace(/[^a-z0-9äöü\-.\s]/gi, '').split(".");
    setDomain(tokens[0]);
    if (domainPackages.find((element) => element.tld === tokens[1]))
      setTld(tokens[1]);
    setCheckResult(0);
  }

  const registerDomain = () => {
    callAPI("domain", "POST", "order", {domain: domain, tld: tld, accountId: account.id, mode: 'register'}).then((response) => {
      props.onClose(true);
    });
  }

  const checkDomain = () => {
    setCheckResult(1);
    callAPI('domain', 'POST', 'check', {domain: domain, tld: tld}).then((response) => {
        setCheckResult(response.available ? 3: 2)
    });
  }

  const tldSelectorHtml = domainPackages.map((element) => {
    return <option selected={element.tld === tld} value={element.tld}>.{element.tld}</option>
  });

  const currentPackage = domainPackages.filter((element) => element.tld === tld)[0]

  return (
    <Popup
      title={'Domain hinzufügen für Webseite #' + ('00000' + account.id).slice(-5)}
      confirmButton={"Kostenpflichtig bestellen"}
      cancelButton={"Abbrechen"}
      onConfirm={() => registerDomain()}
      onCancel={() => props.onClose(false)}
      disableConfirm={checkResult !== 3}
    >
      <div className={'add-domain-dialog'}>
        <div className={'info-text'}>
          Bitte hier deine Wunschdomain ein und wähle die Domain-Endung aus. Dann klicke auf den Button um die Verfügbarkeit zu prüfen.
        </div>
        <div className={'input-box'}>
          <input value={domain} onChange={(e) => checkUserInput(e.target.value)}/>
          <select onChange={(e) => setTld(e.target.value)}>{tldSelectorHtml}</select>
        </div>
        {checkResult === 0 &&
        <div className={'check-box'}>
          <div className={'simple-button'} onClick={checkDomain}>
            Verfügbarkeit der Domain überprüfen
          </div>
        </div>
        }
        {checkResult === 1 &&
        <div className={'result-text'}>
          Prüfung wird durchgeführt...
        </div>
        }
        {checkResult === 2 &&
          <div className={'result-text result-not-available'}>
            Die Domain ist leider schon vergeben, trage bitte eine neue Domain ein
          </div>
        }
        {checkResult === 3 &&
        <div className={'result-text result-available'}>
          Die Domain ist verfügbar und kann registriert werden
        </div>
        }

        <div className={'info-text'} style={{marginTop: 30, marginBottom: 30}}>
          Für den Registrierung der Domain fallen Kosten in Höhe von <b>{currentPackage.price.toFixed(2).replace('.', ",")}€ pro Monat bzw. {currentPackage.price * 12}€ pro Jahr inkl. MwSt.</b> an.<br/>Der Betrag wird jährlich im Voraus über die bevorzugte Zahlungsart abgerechnet.
        </div>
      </div>
    </Popup>
  );
};

const AddDomainDialog = (props) => {
  const [mode, setMode] = useState("");
  const [domainPackages, setDomainPackages] = useState([]);
  const account = props.account;

  useEffect(() => {
    callAPI("domain", "POST", "packages", {}).then((response) => {
      if (response.packages)
        setDomainPackages(response.packages);
    });
  }, []);

  const title = 'Domain hinzufügen für Webseite #' + ('00000' + account.id).slice(-5);

  return (
    <>
      {mode === "" && <AddDomainDialogMode title={title} onSelect={(mode) => mode ? setMode(mode) : props.onClose(false)}/>}
      {mode === "transfer" && <AddDomainDialogTransfer title={title} onClose={props.onClose} domainPackages={domainPackages} account={props.account} />}
      {mode === "link" && <AddDomainDialogLink title={title}  onClose={props.onClose} domainPackages={domainPackages} account={props.account} />}
      {mode === "register" && <AddDomainDialogRegister title={title} onClose={props.onClose} domainPackages={domainPackages} account={props.account} />}
    </>
  );
};

export default AddDomainDialog;